<template>
    <component :is="tag" :class="variantClasses">
        <slot/>
    </component>
</template>

<script setup lang="ts">
type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6
type HeadingVariant = 'page' | 'section' | 'subsection' | 'group' | 'component' | 'supporting'

const props = withDefaults(defineProps<{
    level?: HeadingLevel
    variant?: HeadingVariant
}>(), {
    level: 2,
})

const defaultVariants: Record<HeadingLevel, HeadingVariant> = {
    1: 'page',
    2: 'section',
    3: 'subsection',
    4: 'group',
    5: 'component',
    6: 'supporting',
}

const classes: Record<HeadingVariant, string> = {
    page: 'font-fancy text-5xl font-semibold tracking-wide text-primary',
    section: 'font-fancy text-3xl font-semibold text-text',
    subsection: 'font-fancy text-2xl font-semibold text-primary',
    group: 'font-fancy text-xl font-semibold text-text',
    component: 'font-fancy text-lg font-semibold text-text',
    supporting: 'font-fancy text-base font-semibold text-text',
}

const tag = computed(() => `h${ props.level }`)
const variantClasses = computed(() => classes[props.variant ?? defaultVariants[props.level]])
</script>
